<template>
  <LKPublicationsFormdataModalContainer
    v-if="isActive"
    content-class="LKPublicationsFormdataErrorsModal"
    @close="close"
  >
    <div class="LKPublicationsFormdataErrorsModal__header">
      <div class="text-lg-bold">
        Ошибки заполнения формы
      </div>

      <IconClose
        @click.native="close"
      />
    </div>
    <div class="LKPublicationsFormdataErrorsModal__content">
      <v-row no-gutters>
        <v-col cols="6">
          <ul v-if="!errors['отчёт']" style="padding-left: 24px;">
            <li
              v-for="(values, key) in textPreparedErrors"
              :key="key"
            >
              {{ getSheetNameByKey(key) }}
              <ul style="padding-left: 24px;">
                <li
                  v-for="error in values"
                  :key="error"
                >
                  {{ error }}
                </li>
              </ul>
            </li>
          </ul>
        </v-col>

        <v-col cols="6">
          <ul style="padding-left: 24px;">
            <li
              v-for="(values, key) in textPreparedBackendErrors"
              :key="key"
            >
              {{ getSheetNameByKey(key) }}
              <ul style="padding-left: 24px;">
                <li
                  v-for="error in values"
                  :key="error"
                >
                  {{ error }}
                </li>
              </ul>
            </li>
          </ul>
        </v-col>
      </v-row>

      <template v-if="errors['отчёт']">
        <v-row v-for="(error, index) in errors['отчёт']" :key="`error-${index}`" no-gutters>
          <v-col>
            <p class="error--text">
              {{ error }}
            </p>
          </v-col>
        </v-row>
      </template>
    </div>
  </LKPublicationsFormdataModalContainer>
</template>

<script>
import IconClose from '@/components/lk/icons/LKIconClose.vue'
import LKPublicationsFormdataModalContainer from './LKPublicationsFormdataModalContainer.vue'


export default {
  name: 'LKPublicationsFormdataErrorsModal',
  components: {
    IconClose,
    LKPublicationsFormdataModalContainer,
  },
  inheritAttrs: false,
  props: {
    textPreparedErrors: {
      type: Object,
      required: true,
    },
    textPreparedBackendErrors: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    sheets: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isActive: false,
  }),
  methods: {
    open() {
      // ждем подгрузки стилей для анимации модалки
      setTimeout(() => { this.isActive = true }, 300)

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    close() {
      this.isActive = false
      this.resolve()
      this.resolve = null
      this.$emit('closed')
    },
    getSheetNameByKey(key) {
      return this.sheets[key]?.name || key
    },
  },
}
</script>

<style lang="scss">
$btn-blue: $webflow-color-blue-dark;
$modal-padding: 20px;

.LKPublicationsFormdataErrorsModal {
  position: absolute;
  top: $modal-padding;
  right: $modal-padding;
  left: $modal-padding;
  z-index: 5;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - #{2 * $modal-padding});
  padding: $modal-padding;
  margin: 0 auto;
  overflow: unset;
  background-color: $color-white;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  @media (min-width: 767px) {
    max-width: calc(50% - #{2 * $modal-padding});
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;

    .LKIconClose {
      cursor: pointer;
    }
  }

  &__content {
    padding: 20px 0.25rem;
    margin-right: -0.25rem;
    margin-left: -0.25rem;
    overflow-y: auto;

    &__odd {
      background-color: $webflow-color-blue-shadow;
    }
  }
}
</style>
